import type { VisualModule, VisualSample } from './types';
type Shape={x:number;y:number;r:number;life:number;h:number;kind:number};
export class ShapeVisual implements VisualModule{
  private shapes:Shape[]=[]; private tick=0;
  draw(ctx:CanvasRenderingContext2D,w:number,h:number,s:VisualSample){
    this.tick++;
    if(!s.frozen&&this.tick%(s.reducedMotion?12:6)===0){
      for(const [i,p] of [s.left,s.right].entries()) if(p) this.shapes.push({x:p.x*w,y:p.y*h,r:18+s.movement.gestureScale*70,life:1,h:i?326:186,kind:Math.floor(Math.random()*3)});
    }
    this.shapes=this.shapes.slice(-(s.reducedMotion?24:64)).filter(x=>x.life>.03);
    ctx.save();ctx.lineCap='round';
    for(const sh of this.shapes){sh.life*=.978;sh.r+=.5+s.movement.bodyExpansion;sh.y-=.15+s.movement.verticalDirection*.45;ctx.globalAlpha=sh.life*.8;ctx.strokeStyle=`hsl(${sh.h} 95% 72%)`;ctx.lineWidth=3+8*s.movement.movementEnergy;ctx.shadowColor=ctx.strokeStyle;ctx.shadowBlur=12;ctx.beginPath();if(sh.kind===0)ctx.arc(sh.x,sh.y,sh.r,0,Math.PI*2);else if(sh.kind===1)ctx.arc(sh.x,sh.y,sh.r,Math.PI*.1,Math.PI*1.5);else{for(let a=0;a<Math.PI*3;a+=.16){const r=sh.r*a/(Math.PI*3);const x=sh.x+Math.cos(a)*r,y=sh.y+Math.sin(a)*r;if(a===0)ctx.moveTo(x,y);else ctx.lineTo(x,y);}}ctx.stroke();}
    ctx.restore();
  }
  clear(){this.shapes=[];}
}
